import type { ChainType } from '@polaris/core/models'
import { isAddressValid } from '@polaris/core/utils'
import { queryOptions } from '@tanstack/react-query'
import { webChainDataProvider } from '@/src/services/chain-data-provider'

export const isAddressValidQuery = ({
  address,
  chainType,
  chainId,
  enabled = true,
}: {
  address: string
  chainType?: ChainType
  chainId?: string
  enabled?: boolean
}) =>
  queryOptions({
    queryKey: ['isAddressValid', address, chainType, chainId],
    queryFn: async () => {
      if (!address || !chainType) return undefined
      try {
        // getAddress returns undefined or throws if invalid
        const result = await isAddressValid(
          address,
          chainType,
          webChainDataProvider,
          chainId,
        )
        return !!result
      } catch {
        return false
      }
    },
    enabled: enabled && !!address && !!chainType && !!chainId,
  })
